// #region System type
export const SYSTEM_TYPE = {
    EE: 1,
    EI: 2,
    EB: 3
} as const;

export type SystemType = (typeof SYSTEM_TYPE)[keyof typeof SYSTEM_TYPE];
// #endregion System type

// #region Roles
export const ROLE = {
    EA_STD: 0,
    JIHO_ADMIN: 1,
    GROUP_ADMIN: 2,
    STD_INDIVIDUAL: 3,
    STD_GROUP: 4
} as const;

export type RoleType = (typeof ROLE)[keyof typeof ROLE];
// #endregion Roles

export const LANGUAGES_SUPPORTED = {
    Japanese: 'ja',
    English: 'en'
} as const;

export type LanguagesSupported = (typeof LANGUAGES_SUPPORTED)[keyof typeof LANGUAGES_SUPPORTED];

export const STATUS = {
    Inactive: 0,
    Active: 1,
    WaitConfirm: 2
} as const;

export type Status = (typeof STATUS)[keyof typeof STATUS];

export const GENDER = {
    Male: 0,
    Female: 1
} as const;

export type Gender = (typeof GENDER)[keyof typeof GENDER];

export const PUBLICATION_TYPE = {
    Book: 'BOOK',
    MagazineIssue: 'MAGAZINE_ISSUE'
} as const;

export type PublicationType = (typeof PUBLICATION_TYPE)[keyof typeof PUBLICATION_TYPE];

export const TYPE_SEARCH = {
    OR: 'OR',
    AND: 'AND'
} as const;

export type TypeSearch = (typeof TYPE_SEARCH)[keyof typeof TYPE_SEARCH];
export const STEP_STATUS = {
    DISABLE: 0,
    ACTIVE: 1,
    PASS: 2
} as const;

export type StepStatus = (typeof STEP_STATUS)[keyof typeof STEP_STATUS];

// #region Role
export const EA_ROLE = {
    EA_STD: 0,
    JIHO_ADMIN: 1,
    GROUP_ADMIN: 2
};

export type EARole = (typeof EA_ROLE)[keyof typeof EA_ROLE];

export const SUB_SYSTEM_ROLE = {
    JIHO_ADMIN: 1,
    GROUP_ADMIN: 2,
    STD_INDIVIDUAL: 3,
    STD_GROUP: 4
};

export type SubSystemRole = (typeof SUB_SYSTEM_ROLE)[keyof typeof SUB_SYSTEM_ROLE];

// #endregion

// #region Work
export const WORK_FORM = {
    OTHER: 0,
    OFFSHORE: 1,
    OUTSIDE: 2
} as const;

export type WorkForm = (typeof WORK_FORM)[keyof typeof WORK_FORM];

export const TOOL_CERTIFICATE_TYPE = {
    NEW: 1,
    UPDATE: 2
} as const;

export type ToolCertificateType = (typeof TOOL_CERTIFICATE_TYPE)[keyof typeof TOOL_CERTIFICATE_TYPE];

// #endregion

export const CONFIRM_EMAIL_STATUS = {
    CONFIRM_EMAIL_SUCCESS: 1,
    CONFIRM_EMAIL_NOT_EXISTED_OR_EXPIRED_OR_ALREADY_CONFIRM: 2,
    CONFIRM_EMAIL_ALREADY_USE: 3
} as const;

export type ConfirmEmailStatus = (typeof CONFIRM_EMAIL_STATUS)[keyof typeof CONFIRM_EMAIL_STATUS];

export const ORDER_STATUS = {
    NOT_PAID: 0, // waiting for payment
    PAID: 1, // paid successfully
    FAILURE: 2 // failed to pay
} as const;

export type OrderStatus = (typeof ORDER_STATUS)[keyof typeof ORDER_STATUS];

export const PUBLICATION_COLLECTION_TYPE = {
    BOOKSHELF: 'BOOKSHELF',
    FAVORITE: 'FAVORITE',
    HISTORY: 'HISTORY'
} as const;

export type PublicationCollectionType = (typeof PUBLICATION_COLLECTION_TYPE)[keyof typeof PUBLICATION_COLLECTION_TYPE];

export const PACKAGE_TYPE = {
    UNLIMITED: 'UNLIMITED',
    SPECIFIED: 'SPECIFIED'
} as const;

export type PackageType = (typeof PACKAGE_TYPE)[keyof typeof PACKAGE_TYPE];

export const SYNCHRONOUS_ORIGIN = {
    EB: 'EB',
    EE: 'EE',
    EI: 'EI'
} as const;

export type SynchronousOrigin = (typeof SYNCHRONOUS_ORIGIN)[keyof typeof SYNCHRONOUS_ORIGIN];
